import { FormControl, TextField, Typography } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { ReactConfirmProps, confirmable, createConfirmation } from 'react-confirm';
import * as Yup from 'yup';
import { WithChildrenProps } from '../';
import CommentTaskType from '../../enum/CommentTaskType';
import TaskApi from '../../service/TaskApi';
import { getThemeForMode } from "../../themes/ThemeBlue";
import DefaultButton from '../FormControl/DefaultButton';
import { FormValidationSchema } from '../FormControl/Form/Form';
import FormDialog, { FormDialogNoTheme } from '../FormControl/FormDialog';
import ErrorButton from './../FormControl/ErrorButton';
import FixedIds from '../../enum/FixedIds';
import TaskSendEmailType from '../../enum/TaskSendEmailType';
import Task from '../../model/Task';

interface ConfirmationOptions {
    onProceed: () => Promise<any> | any;
    onCancel?: () => any;
    user_id: number;
    tasks: Task[];
    newTask: Task;
}

interface TaskPauseCommentDialogProps extends WithChildrenProps {
    options: ConfirmationOptions,
    ProceedButton?: React.ComponentType<ButtonProps>
}

interface TaskPauseCommentDialogFormData {
    comment: string;
}

export class TaskPauseCommentDialog extends React.Component<ReactConfirmProps & TaskPauseCommentDialogProps> {

    private taskApi: TaskApi;

    constructor(props: ReactConfirmProps & TaskPauseCommentDialogProps) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.getValidationSchema = this.getValidationSchema.bind(this);
        this.taskApi = new TaskApi();
    }

    async onSubmit(comment: string) {
        const { options, proceed } = this.props;
        const { onProceed, tasks, user_id, newTask } = options;
        try {
            await Promise.all(tasks.map(async (task, index) => {
                let newComment = `O usuário ${newTask.user?.name} trocou essa tarefa pela tarefa ${newTask.ticket_code} - ${newTask.name}.\nJustificativa: ${comment}`;
                await this.taskApi.saveComment(task.id, newComment, false, FixedIds.lanzabotId, CommentTaskType.PreService, undefined, undefined, []);
                await this.taskApi.update(task.id, { ticket_status_id: FixedIds.taskStatusPauseTempId });
                await this.taskApi.sendEmail(task.id, TaskSendEmailType.StatusChangeObserver, user_id, task.ticket_status_id);
                return;
            }));

            if ((await Promise.resolve(onProceed())) === false) {
                return;
            }
            if (typeof proceed === 'function') {
                proceed('ok');
            }
        } catch (e) {
            console.log(e);
        }
    }

    getValidationSchema() {
        const validationSchema: FormValidationSchema<TaskPauseCommentDialogFormData> = {
            comment: Yup.string()
                .trim()
                .required()
                .min(3)
                .label('Comentário')
        }
        return validationSchema;
    }

    render() {
        const { show, dismiss, options } = this.props;
        const { onCancel } = options;
        var theme = localStorage.getItem("theme");
        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={getThemeForMode(theme)}>
                    <FormDialogNoTheme<TaskPauseCommentDialogFormData>
                        show={show}
                        title={'Você já possui uma tarefa em atendimento. Deseja mesmo colocar esta tarefa em atendimento? Se sim, informe o motivo.'}
                        dismiss={() => dismiss()}
                        onSubmit={(values, dirty, errors) => {
                            if (errors && Object.keys(errors).length > 0) {
                                return;
                            }
                            const { comment } = values;
                            if (comment)
                                this.onSubmit(comment);
                        }}
                        initialValues={{ comment: '' }}
                        enableReinitialize={true}
                        maxWidth='sm'
                        fullWidth
                        validationSchema={this.getValidationSchema()}
                    >
                        {({ values, errors, setFieldValue, isSubmitting, handleChange, dirty }) => (
                            <>
                                <FormControl fullWidth variant="outlined" margin='dense'>
                                    <TextField
                                        name="comment"
                                        label={"Motivo"}
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        required
                                        autoFocus
                                        inputProps={{
                                            style: {
                                                resize: 'vertical', overflow: 'auto', height: 165, minHeight: 165, maxHeight: 400
                                            }
                                        }}
                                        value={values.comment}
                                        onChange={handleChange}
                                        error={!!errors.comment && !!dirty.comment}
                                        helperText={!!errors.comment && !!dirty.comment && errors.comment}
                                    />
                                </FormControl>
                                <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <ErrorButton
                                        size='small'
                                        variant='contained'
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            if (typeof onCancel === 'function') {
                                                onCancel();
                                            }
                                            if (typeof onCancel !== 'function') {
                                                dismiss();
                                            }
                                        }} >
                                        Cancelar
                                    </ErrorButton>
                                    <DefaultButton
                                        size='small'
                                        type='submit'
                                        variant="contained"
                                        disabled={isSubmitting}>
                                        OK
                                    </DefaultButton>
                                </FormControl>
                            </>
                        )}
                    </FormDialogNoTheme>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }
}

const ConfirmableDialog = confirmable<TaskPauseCommentDialogProps>(TaskPauseCommentDialog);

const confirm = createConfirmation(ConfirmableDialog, 400, document.querySelector('.App'));

export default function taskPauseCommentDialog(options: ConfirmationOptions) {
    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirm({ options });
}